import * as Container from './container';
import { content } from './content';
import { classNames, selectors } from './lib';
import * as Utils from './utils';

const loopInterval = {};
const loopTimeout = {};

export const stopLoop = (ctrId) => {
	clearTimeout(loopTimeout[ctrId]);
	clearInterval(loopInterval[ctrId]);
};

// Handles the playback state depending on the element type.
export const handleContentState = (ctrId, elm, type, active = true) => {
	if (['video', 'animation'].includes(type)) {
		if (active) {
			if (!Container.hasAutoplay(document.getElementById(ctrId))) {
				// Make sure the content begins from new when it is clicked
				switch (type) {
					case 'video':
						elm.currentTime = 0;
						break;
					case 'animation':
						elm.stop();
						break;
				}
			}
			elm.play();
		} else {
			elm.pause();
		}
	}
};

// Activates the content and the associated navigation element and also deactivates the previously activated elements.
export const activateItems = (ctrId, elmId = 0) => {
	const prevElm = content[ctrId].objs.find((elm) => elm.active === true),
		currentElm = content[ctrId].objs[elmId];

	if (prevElm) {
		prevElm.ctr.classList.remove(classNames.activeContent);
		prevElm.nav.classList.remove(classNames.activeNav);
		prevElm.nav.querySelector('.h6').setAttribute('role', 'button');
		prevElm.active = false;

		handleContentState(ctrId, prevElm.el, prevElm.type, false);
	}

	currentElm.ctr.classList.add(classNames.activeContent);
	currentElm.nav.classList.add(classNames.activeNav);
	currentElm.nav.querySelector('.h6').removeAttribute('role');
	currentElm.active = true;

	handleContentState(ctrId, currentElm.el, currentElm.type);
};

// Loops through the content array at the default speed or a calculated speed based on the number of runs and the duration of a single run.
export const startAutoLoop = (ctrId, sessionDuration = null) => {
	const ctr = document.getElementById(ctrId),
		defaultDuration = parseInt(ctr.getAttribute('data-default-duration')),
		intervalSpeed = 100;
	let index = content[ctrId].session.index,
		duration = content[ctrId].objs[index].loopDuration ? content[ctrId].objs[index].loopDuration : defaultDuration;

	// If the session was interrupted, the remaining time overwrites the duration.
	if (sessionDuration !== null) {
		duration = sessionDuration;
	}

	content[ctrId].session = { ...content[ctrId].session, duration, timeLeft: duration };

	const nav = content[ctrId].objs[index].nav.querySelector('.inner');

	// Set the initial animation to start at 100% if it was not interrupted.

	if (sessionDuration === null || sessionDuration === 0) {
		content[ctrId].session.animation = nav.animate([{ strokeDasharray: '100 0' }, { strokeDasharray: '0 100' }], {
			duration,
		});
	} else {
		content[ctrId].session.animation.play();
	}

	// The timeout function handles the process for automatically displaying the next element.
	// only if Container has autoplay active switch between slides and restart animation on index switch
	if (Container.hasAutoplay(document.getElementById(ctrId))) {
		loopTimeout[ctrId] = setTimeout(() => {
			if (index < content[ctrId].objs.length - 1) {
				// Continue to next slide
				index++;
			} else {
				// Start with first slide again
				index = 0;
			}
			content[ctrId].session.index = index;
			stopLoop(ctrId);
			activateItems(ctrId, index);
			startAutoLoop(ctrId);
		}, duration);
	} else {
		loopTimeout[ctrId] = setTimeout(() => {
			stopLoop(ctrId);
			startAutoLoop(ctrId);
		}, duration);
	}

	// The interval captures the remaining time when the loop is interrupted.
	loopInterval[ctrId] = setInterval(() => {
		content[ctrId].session.timeLeft = content[ctrId].session.timeLeft - intervalSpeed;
	}, intervalSpeed);
};

// Variables that are needed in all addEventListeners are combined in one object.
export const getTheCtrByEvent = (event) => {
	const elm = event.target;
	const ctr = elm.closest(selectors.primaryCtr);

	return {
		elm,
		ctr,
		ctrId: ctr.id,
	};
};

// Pauses the active stage and the navigation and continues playing at the point where you left it.
export const theaterPausePlay = (event) => {
	const { elm, ctrId } = getTheCtrByEvent(event);
	const contentElm = content[ctrId].objs[Utils.getIndex(elm)];

	if (elm.classList.contains(classNames.activeNav) || elm.classList.contains(classNames.activeContent)) {
		if (Container.hasAutoplay(elm.closest(selectors.primaryCtr))) {
			if (event.type === 'mouseenter') {
				theaterPause(contentElm, ctrId);
				handleContentState(ctrId, contentElm.el, contentElm.type);
			} else {
				theaterPlay(contentElm, ctrId);
				handleContentState(ctrId, contentElm.el, contentElm.type);
			}
		}
	}
};

// Pauses the content
export const theaterPause = (contentElm, ctrId) => {
	document.getElementById(ctrId).setAttribute('data-paused', 1);
	contentElm.nav.classList.add(classNames.navPause);
	contentElm.type !== 'image' && contentElm.el.pause(); // trigger only on Animations or Videos
	clearTimeout(loopTimeout[ctrId]);
	clearInterval(loopInterval[ctrId]);
};

// Plays the content
export const theaterPlay = (contentElm, ctrId) => {
	document.getElementById(ctrId).setAttribute('data-paused', 0);
	contentElm.nav.classList.remove(classNames.navPause);
	contentElm.type !== 'image' && contentElm.el?.play(); // trigger only on Animations or Videos
	startAutoLoop(ctrId, content[ctrId].session.timeLeft);
};
